import { render, staticRenderFns } from "./detailGx.vue?vue&type=template&id=5de745fc&scoped=true"
import script from "./detailGx.vue?vue&type=script&lang=js"
export * from "./detailGx.vue?vue&type=script&lang=js"
import style0 from "./detailGx.vue?vue&type=style&index=0&id=5de745fc&prod&scoped=true&lang=scss"
import style1 from "./detailGx.vue?vue&type=style&index=1&id=5de745fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de745fc",
  null
  
)

export default component.exports